function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#0074d9;}.cls-3{fill:none;stroke:#636569;stroke-miterlimit:10;}.cls-4{fill:#636569;}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  className: "cls-1",
  x: 0.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 4.5
}), React.createElement("path", {
  className: "cls-2",
  d: "M27,1a4,4,0,0,1,4,4V27a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V5A4,4,0,0,1,5,1H27m0-1H5A5,5,0,0,0,0,5V27a5,5,0,0,0,5,5H27a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M7,12.5H26a1,1,0,0,1,1,1v6a0,0,0,0,1,0,0H6a0,0,0,0,1,0,0v-6a1,1,0,0,1,1-1Z",
  transform: "translate(39.48 15.65) rotate(135)"
}), React.createElement("line", {
  className: "cls-3",
  x1: 11.04,
  y1: 21.14,
  x2: 9.08,
  y2: 19.18
}), React.createElement("line", {
  className: "cls-3",
  x1: 12.45,
  y1: 18.31,
  x2: 11.2,
  y2: 17.06
}), React.createElement("line", {
  className: "cls-3",
  x1: 15.28,
  y1: 16.9,
  x2: 13.32,
  y2: 14.94
}), React.createElement("line", {
  className: "cls-3",
  x1: 16.69,
  y1: 14.07,
  x2: 15.44,
  y2: 12.82
}), React.createElement("line", {
  className: "cls-3",
  x1: 19.52,
  y1: 12.66,
  x2: 17.56,
  y2: 10.7
}), React.createElement("circle", {
  className: "cls-4",
  cx: 21.64,
  cy: 10.54,
  r: 1
})));

function SvgMeasure(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/measure.12b354e7.svg";
export { SvgMeasure as ReactComponent };